module.exports = __webpack_public_path__ + "static/media/consultation_02.78a5418e.png";


//////////////////
// WEBPACK FOOTER
// ./src/presentation/assets/img/consultation_02.png
// module id = 575
// module chunks = 0